import { useIsFetching } from "@tanstack/react-query";
import { Select, Col, Row } from "antd";
import { useVolSurfaceControlTable } from "contexts/VolSurfaceControlTableContext";
import { storeInLocalStorage } from "helpers/Pricer/Table";
import { useEffect } from "react";

export default function SetComparisonSurface({
  dark_Theme,
  disabledCondition,
  setSelectedFilters,
  comparisonGraph,
  setComparisonGraph,
  userVolSurfaces,
  comparison_surface_id,
  setComparisonSurfaceId,
}) {
  const { lockedData } = useVolSurfaceControlTable();
  const isFetching = useIsFetching();
  function onChangeHandle(e) {
    setSelectedFilters((prev) => ({
      ...prev,

      comparison_surface_id: e ? e : "",
    }));
    storeInLocalStorage("IsComparisonSurfaceChanged", JSON.stringify(true));
    storeInLocalStorage("IsComparisonSurfaceChanged", JSON.stringify(true));
    setComparisonGraph(e);
    setComparisonSurfaceId(e);
    setComparisonSurfaceId(e);
  }

  useEffect(() => {
    storeInLocalStorage("IsComparisonSurfaceChanged", JSON.stringify(false));

    return () => {
      storeInLocalStorage("IsComparisonSurfaceChanged", JSON.stringify(false));
    };
  }, []);

  useEffect(() => {
    setComparisonSurfaceId(comparison_surface_id);
  }, [comparison_surface_id, setComparisonSurfaceId]);


  useEffect(() => {
    storeInLocalStorage("IsComparisonSurfaceChanged", JSON.stringify(false));

    return () => {
      storeInLocalStorage("IsComparisonSurfaceChanged", JSON.stringify(false));
    };
  }, []);

  useEffect(() => {
    setComparisonSurfaceId(comparison_surface_id);
  }, [comparison_surface_id, setComparisonSurfaceId]);

  return (
    <Col span={24}>
      <Row gutter={[25, 25]}>
        <Col span={3}>Set Comparison Surface:</Col>
        <Col>
          <Select
            loading={isFetching}
            placeholder="Select Comparison"
            className={dark_Theme ? "select-dark" : ""}
            popupClassName={dark_Theme ? "dropdown-dark" : ""}
            style={{ width: 180 }}
            allowClear
            value={
              userVolSurfaces?.length > 0 && !isFetching
                ? comparison_surface_id !== null &&
                  comparison_surface_id !== undefined
                  ? Number(comparison_surface_id) : null
                : null
            }
            defaultValue={comparison_surface_id}
            disabled={
              disabledCondition || lockedData?.lock_comparison_surface_dropdown
            }
            onChange={(e) => onChangeHandle(e)}
            showSearch
            filterOption={(input, option) => {
              const inputSmallLetter = input.toLowerCase();
              const label = option.label.toLowerCase();
              return label.includes(inputSmallLetter);
            }}
            options={userVolSurfaces?.map((data) => ({
              value: data.id,
              label: data.title,
            }))}
          />
        </Col>
      </Row>
    </Col>
  );
}
